module.exports = __webpack_public_path__ + "img/logo.ae204840.svg";